export const loadCatalogList = ({ products }) => {
    try {
        let ecommerceProducts = products.map((product, index) => {
            return {
                item_id: product.id,
                item_name: product.name,
                price: product.priceClean,
                index: index,
                quantity: 1,
            };
        });

        if (window.dataLayer) {
            window.dataLayer.push({
                event: 'view_item_list',
                ecommerce: {
                    currencyCode: 'RUB',
                    items: [ecommerceProducts],
                },
            });
        }
    } catch (err) {
        console.error(err.message);
    }
};

export const selectProduct = (product) => {
    if (window.dataLayer) {
        window.dataLayer.push({
            event: 'select_item',
            ecommerce: {
                currencyCode: 'RUB',
                item: {
                    item_id: product.id,
                    item_name: product.name,
                    price: product.price,
                    index: 0,
                    quantity: 1,
                    item_list_name: product.catalog,
                    item_list_id: product.catalogId,
                },
            },
        });
    }
};
